var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.616 198.141H366.836V210.182H400.616V198.141Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03997 447.013H849.582V569.437L776.873 520.964L671.228 566.329L564.34 520.964L471.745 607.345L371.693 635.931L327.57 599.266L292.769 546.443L259.832 578.137L186.502 516.614L135.544 524.071L78.37 474.978L4.41797 456.335L5.03997 447.013Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M412.977 197.927H400.403V208.37H412.977V197.927Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M418.885 361.392H517.241L508.929 371.942H418.143L418.885 361.392Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M418.965 325.961H454.876V247.426L473.95 223.237V206.294L458.286 202.564L454.45 202.884V225.688L432.605 249.771L423.121 258.616L418.965 325.961Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M426.558 232.879H442.222H426.558Z",
    fill: "#131F2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M426.558 232.879H442.222",
    stroke: "#F7F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M389.457 342.649L389.532 325.997L376.949 324.565L373.483 270.765L373.709 217.417H383.354L387.348 212.519L393.075 212.67V211.314L423.29 195.114L427.208 195.039L427.133 214.404C424.776 215.822 425.068 218.255 427.058 219.905V224.426L423.969 226.988L431.052 229.55L427.661 232.112V250.573L425.022 260.423V275.438L419.147 329.464H416.585C415.284 331.915 414.009 331.491 412.742 330.142V324.943H408.975L408.448 325.998V342.5L389.457 342.649Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M408.483 325.922H389.532V342.537H408.483V325.922Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M419.305 341.322H379.533V382.755H419.305V341.322Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M410.45 375.764C410.45 381.942 405.442 386.95 399.264 386.95C393.086 386.95 388.078 381.942 388.078 375.764C388.078 369.586 393.086 364.578 399.264 364.578C405.442 364.578 410.45 369.586 410.45 375.764Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M406.41 376.385C406.41 380.16 403.349 383.221 399.574 383.221C395.799 383.221 392.738 380.16 392.738 376.385C392.738 372.61 395.799 369.549 399.574 369.549C403.349 369.549 406.41 372.61 406.41 376.385Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M429.093 382.677H370.522V403.262H429.093V382.677Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M372.076 403.107V405.748L382.33 410.564V419.264L371.299 433.246H430.336L417.13 418.643V410.564L427.706 405.528L427.861 403.016L372.076 403.107Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M390.518 432.958V415.247C391.5 406.306 407.52 406.442 409.317 415.247V433.114L390.518 432.958Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M370.367 392.232H429.093H370.367Z",
    fill: "#131F2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M370.367 392.232H429.093",
    stroke: "#F7F9F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M401.681 375.208C401.681 376.323 400.777 377.228 399.661 377.228C398.546 377.228 397.641 376.324 397.641 375.208C397.641 374.093 398.545 373.188 399.661 373.188C400.777 373.189 401.681 374.093 401.681 375.208Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M443.033 433.502H357.585V446.242H443.033V433.502Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M376.023 403.109H373.319V405.75H376.023V403.109Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.9341
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M385.026 403.107H381.297V405.748H385.026V403.107Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M426.475 403.069H423.532V405.71H426.475V403.069Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.8884
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M419.15 403.111H415.421V405.752H419.15V403.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M408.751 403.011H404.143V405.652H408.751V403.011Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M397.159 403.13H392.661V405.771H397.159V403.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M379.307 348.779H419.624H379.307Z",
    fill: "#131F2E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M379.307 348.779H419.624",
    stroke: "#F7F9F9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M404.064 418.419C404.064 420.65 402.255 422.458 400.025 422.458C397.794 422.458 395.986 420.649 395.986 418.419C395.986 416.188 397.795 414.38 400.025 414.38C402.256 414.379 404.064 416.188 404.064 418.419Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M418.326 648.388L454.93 652.331L417.847 655.102L418.326 648.388Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M418.006 669.487L454.61 665.544L417.527 662.773L418.006 669.487Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M421.016 447.067H379.031V744.159H421.016V447.067Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M397.999 515.906V534.661L402.475 531.89V515.48L397.999 515.906Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M395.868 510.791V517.185H403.967V506.529L395.868 510.791Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M390.54 446.428V517.398L409.082 506.529V446.642L390.54 446.428Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M382.042 669.22L345.438 665.277L382.521 662.506L382.042 669.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M381.722 648.121L345.118 652.064L382.201 654.835L381.722 648.121Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M379.974 622.563H420.154L420.117 700.885L380.024 700.992L379.974 622.563Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M391.179 462.625H409.508C410.685 462.625 411.639 463.579 411.639 464.756V478.396C411.639 479.573 410.685 480.527 409.508 480.527H391.179C390.002 480.527 389.048 479.573 389.048 478.396V464.756C389.048 463.579 390.002 462.625 391.179 462.625Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M393.097 578.35V673.829L390.113 675.747V691.518H409.294V675.747L406.31 673.616V575.793L393.097 578.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M390.54 581.121L390.753 536.792L409.273 526.099V577.285L390.54 581.121Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M390.54 546.382H409.082C410.259 546.382 411.213 547.336 411.213 548.513V559.808C411.213 560.985 410.259 561.939 409.082 561.939H390.54C389.363 561.939 388.409 560.985 388.409 559.808V548.513C388.409 547.336 389.363 546.382 390.54 546.382Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M393.39 583.039L394.625 583.87L393.39 583.039Z",
    fill: "#131F2E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M393.39 583.039L394.625 583.87",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M393.439 595.118L394.674 595.949L393.439 595.118Z",
    fill: "#131F2E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M393.439 595.118L394.674 595.949",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 589.071L394.621 589.902L393.386 589.071Z",
    fill: "#131F2E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 589.071L394.621 589.902",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M393.426 601.139L394.661 601.97L393.426 601.139Z",
    fill: "#131F2E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M393.426 601.139L394.661 601.97",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M393.399 607.159L394.634 607.99L393.399 607.159Z",
    fill: "#131F2E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M393.399 607.159L394.634 607.99",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 613.193L394.621 614.024L393.386 613.193Z",
    fill: "#131F2E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 613.193L394.621 614.024",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M393.412 619.227L394.647 620.058L393.412 619.227Z",
    fill: "#131F2E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M393.412 619.227L394.647 620.058",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 625.221L394.621 626.052L393.386 625.221Z",
    fill: "#131F2E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 625.221L394.621 626.052",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 631.322L394.621 632.153L393.386 631.322Z",
    fill: "#131F2E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 631.322L394.621 632.153",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M393.412 637.316L394.647 638.147L393.412 637.316Z",
    fill: "#131F2E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M393.412 637.316L394.647 638.147",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 643.363L394.621 644.194L393.386 643.363Z",
    fill: "#131F2E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 643.363L394.621 644.194",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 649.331L394.621 650.162L393.386 649.331Z",
    fill: "#131F2E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 649.331L394.621 650.162",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 655.378L394.621 656.209L393.386 655.378Z",
    fill: "#131F2E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 655.378L394.621 656.209",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 661.399L394.621 662.23L393.386 661.399Z",
    fill: "#131F2E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 661.399L394.621 662.23",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 667.446L394.621 668.277L393.386 667.446Z",
    fill: "#131F2E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M393.386 667.446L394.621 668.277",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M405.991 586.06L404.756 586.891L405.991 586.06Z",
    fill: "#131F2E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M405.991 586.06L404.756 586.891",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M405.943 598.139L404.708 598.97L405.943 598.139Z",
    fill: "#131F2E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M405.943 598.139L404.708 598.97",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 592.092L404.761 592.923L405.996 592.092Z",
    fill: "#131F2E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 592.092L404.761 592.923",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M405.956 604.16L404.721 604.991L405.956 604.16Z",
    fill: "#131F2E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M405.956 604.16L404.721 604.991",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M405.983 610.18L404.748 611.011L405.983 610.18Z",
    fill: "#131F2E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M405.983 610.18L404.748 611.011",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 616.214L404.761 617.045L405.996 616.214Z",
    fill: "#131F2E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 616.214L404.761 617.045",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M405.969 622.248L404.734 623.079L405.969 622.248Z",
    fill: "#131F2E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M405.969 622.248L404.734 623.079",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 628.242L404.761 629.073L405.996 628.242Z",
    fill: "#131F2E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 628.242L404.761 629.073",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 634.343L404.761 635.174L405.996 634.343Z",
    fill: "#131F2E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 634.343L404.761 635.174",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M405.969 640.337L404.734 641.168L405.969 640.337Z",
    fill: "#131F2E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M405.969 640.337L404.734 641.168",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 646.384L404.761 647.215L405.996 646.384Z",
    fill: "#131F2E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 646.384L404.761 647.215",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 652.352L404.761 653.183L405.996 652.352Z",
    fill: "#131F2E"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 652.352L404.761 653.183",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 658.399L404.761 659.23L405.996 658.399Z",
    fill: "#131F2E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 658.399L404.761 659.23",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 664.42L404.761 665.251L405.996 664.42Z",
    fill: "#131F2E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 664.42L404.761 665.251",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 670.467L404.761 671.298L405.996 670.467Z",
    fill: "#131F2E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 670.467L404.761 671.298",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 580.066L404.761 580.897L405.996 580.066Z",
    fill: "#131F2E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M405.996 580.066L404.761 580.897",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M392.267 696.232L380.107 700.614L380.172 718.343L391.734 723.192L406.546 722.446L420.026 718.237L420.133 700.601L405.055 696.019L392.267 696.232Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M409.348 691.465H389.982V725.884H409.348V691.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M390.54 726.151L393.204 740.377L406.045 740.484L408.816 726.045L390.54 726.151Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M423.36 741.069H377.539V745.118H423.36V741.069Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M454.576 358.651H447.945V374.248H454.576V358.651Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M471.228 359.027V374.323H501.443L501.424 359.027H471.228Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M448.062 361.732C447.883 365.082 447.547 368.424 448.062 371.675V361.732Z",
    fill: "#131F2E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M448.062 361.732C447.883 365.082 447.547 368.424 448.062 371.675",
    stroke: "#F7F9F9",
    strokeWidth: 1.5415
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M454.713 361.71C454.534 365.081 454.198 368.445 454.713 371.717V361.71Z",
    fill: "#131F2E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M454.713 361.71C454.534 365.081 454.198 368.445 454.713 371.717",
    stroke: "#F7F9F9",
    strokeWidth: 1.5465
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M471.365 361.634C471.186 365.005 470.85 368.369 471.365 371.641V361.634Z",
    fill: "#131F2E"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M471.365 361.634C471.186 365.005 470.85 368.369 471.365 371.641",
    stroke: "#F7F9F9",
    strokeWidth: 1.5465
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M501.58 361.634C501.401 365.005 501.065 368.369 501.58 371.641V361.634Z",
    fill: "#131F2E"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M501.58 361.634C501.401 365.005 501.065 368.369 501.58 371.641",
    stroke: "#F7F9F9",
    strokeWidth: 1.5465
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M485.143 360.718V356.404H490.358V360.718H485.143Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M494.479 350.384C494.486 354.118 491.464 357.15 487.73 357.156C483.996 357.163 480.964 354.141 480.958 350.407C480.958 350.399 480.958 350.391 480.958 350.383C480.951 346.649 483.973 343.617 487.707 343.611C491.441 343.604 494.473 346.626 494.479 350.36C494.479 350.368 494.479 350.376 494.479 350.384Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084,
    strokeMiterlimit: 4.8337
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M481.929 353.446L483.667 352.706L481.929 353.446Z",
    fill: "#131F2E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M481.929 353.446L483.667 352.706",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M481.092 351L482.863 350.903L481.092 351Z",
    fill: "#131F2E"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M481.092 351L482.863 350.903",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M481.446 348.199L483.024 348.746L481.446 348.199Z",
    fill: "#131F2E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M481.446 348.199L483.024 348.746",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M482.927 345.72L484.118 346.879L482.927 345.72Z",
    fill: "#131F2E"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M482.927 345.72L484.118 346.879",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M486.648 350.337L491.952 346.112L493.025 347.524L487.67 351.497L486.648 350.337Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M485.051 344.143L485.727 345.688L485.051 344.143Z",
    fill: "#131F2E"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M485.051 344.143L485.727 345.688",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M488.878 350.44C488.882 351.027 488.41 351.506 487.823 351.51C487.236 351.514 486.758 351.042 486.753 350.455C486.753 350.45 486.753 350.445 486.753 350.441C486.749 349.854 487.221 349.375 487.808 349.371C488.395 349.367 488.874 349.839 488.878 350.426C488.878 350.43 488.878 350.435 488.878 350.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084,
    strokeMiterlimit: 4.8337
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M487.788 343.66L487.755 345.334L487.788 343.66Z",
    fill: "#131F2E"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M487.788 343.66L487.755 345.334",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M493.664 353.446L491.926 352.706L493.664 353.446Z",
    fill: "#131F2E"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M493.664 353.446L491.926 352.706",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M494.501 351L492.73 350.903L494.501 351Z",
    fill: "#131F2E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M494.501 351L492.73 350.903",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M494.147 348.199L492.569 348.746L494.147 348.199Z",
    fill: "#131F2E"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M494.147 348.199L492.569 348.746",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M492.666 345.72L491.475 346.879L492.666 345.72Z",
    fill: "#131F2E"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M492.666 345.72L491.475 346.879",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M490.541 344.143L489.865 345.688L490.541 344.143Z",
    fill: "#131F2E"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M490.541 344.143L489.865 345.688",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M494.479 350.384C494.486 354.118 491.464 357.15 487.73 357.156C483.996 357.163 480.964 354.141 480.958 350.407C480.958 350.399 480.958 350.391 480.958 350.383C480.951 346.649 483.973 343.617 487.707 343.611C491.441 343.604 494.473 346.626 494.479 350.36C494.479 350.368 494.479 350.376 494.479 350.384Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.2084,
    strokeMiterlimit: 4.8337
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M386.292 337.337C386.292 338.211 385.584 338.919 384.71 338.919C383.836 338.919 383.128 338.211 383.128 337.337C383.128 336.463 383.836 335.755 384.71 335.755C385.584 335.755 386.292 336.463 386.292 337.337Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M387.574 337.638H381.847V340.953H387.574V337.638Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M395.372 337.356C395.372 338.23 394.664 338.938 393.79 338.938C392.916 338.938 392.208 338.23 392.208 337.356C392.208 336.482 392.916 335.774 393.79 335.774C394.664 335.774 395.372 336.482 395.372 337.356Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M396.653 337.657H390.926V340.972H396.653V337.657Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M405.919 337.375C405.919 338.249 405.211 338.957 404.337 338.957C403.463 338.957 402.755 338.249 402.755 337.375C402.755 336.501 403.463 335.793 404.337 335.793C405.211 335.793 405.919 336.501 405.919 337.375Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M407.201 337.676H401.474V340.991H407.201V337.676Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M415.509 337.356C415.509 338.23 414.801 338.938 413.927 338.938C413.053 338.938 412.345 338.23 412.345 337.356C412.345 336.482 413.053 335.774 413.927 335.774C414.801 335.774 415.509 336.482 415.509 337.356Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M416.791 337.657H411.064V340.972H416.791V337.657Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M389.532 325.922H408.671H389.532Z",
    fill: "#131F2E"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M389.532 325.922H408.671",
    stroke: "#F7F9F9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M413.494 312.811H384.107L381.696 259.765L380.792 259.614C378.137 257.996 378.123 257.012 380.491 256.6C392.756 255.296 404.896 255.496 416.96 256.6C419.371 257.156 419.149 258.08 416.583 259.689L415.754 259.915L413.494 312.811Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M381.696 259.764H416.056C418.511 258.32 421.945 256.39 413.909 256.336C403.963 255.798 393.671 255.119 383.43 256.449C376.764 256.304 378.81 258.805 381.696 259.764Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M387.95 312.588V285.986H409.726V312.737L387.95 312.588Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M388.025 293.37H409.726H388.025Z",
    fill: "#131F2E"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M388.025 293.37H409.726",
    stroke: "#F7F9F9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M396.917 268.879V259.915H401.815V269.685L396.917 268.879Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M392.622 285.76V272.423V267.224H405.808V285.911L392.622 285.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M392.772 273.101H405.883H392.772Z",
    fill: "#131F2E"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M392.772 273.101H405.883",
    stroke: "#F7F9F9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M399.102 211.088V242.81H403.698V210.937L399.102 211.088Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M381.847 205.889L381.772 210.561H391.794L393.226 211.541H415.83V206.191L381.847 205.889Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M391.699 208.978L394.261 211.54H405.262L407.711 209.091L391.699 208.978Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M371.448 197.525V207.547H421.857L421.556 197.299L371.448 197.525Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M442.835 308.165C442.839 311.049 440.505 313.39 437.621 313.394C434.737 313.398 432.396 311.064 432.392 308.18C432.392 308.175 432.392 308.17 432.392 308.164C432.388 305.28 434.722 302.939 437.606 302.935C440.49 302.931 442.831 305.265 442.835 308.149C442.835 308.154 442.835 308.16 442.835 308.165Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M443.581 279.979H432.658V285.307H443.581V279.979Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M424.666 263.356L435.535 256.003L435.428 246.199L426.69 246.465L424.133 260.052L424.666 263.356Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M443.421 238.953L440.864 232.932L450.934 224.141L452.131 224.462L452.16 229.096L443.421 238.953Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M451.786 224.834V209.915H447.31V203.468L457.167 196.914H472.299V208.263H459.565V205.492H454.716L454.476 225.712L451.839 228.616L451.786 224.834Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M466.971 300.013L471.074 304.382L471.127 311.415L473.951 311.468L473.685 299.32L468.25 295.644L464.36 295.697L466.971 300.013Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M464.147 296.39V288.771L465.479 287.546L465.319 265.754L467.077 264.369H481.037V257.229H467.504L466.225 255.577L466.332 233.306L467.835 230.702L473.951 230.642L476.402 234.105L476.562 221.637L473.951 219.825L460.591 234.584L459.272 296.483L464.147 296.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M466.798 300.226L466.731 295.537L459.432 295.564L460.657 234.584L455.436 241.297L455.756 259.945L452.133 262.396L452.2 278.687H455.237L455.277 283.895L452.027 283.922L451.92 303.955L455.05 304.008L466.798 300.226Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M466.838 311.202L478.773 312.587L479.625 224.994L482.715 222.543L482.395 210.182L494.969 209.862L497.313 207.837L505.198 207.944L559.651 221.051L558.372 260.905L557.093 262.184L557.519 296.923L552.191 302.89V306.726L554.162 307.152L554.055 329.157L521.767 340.506H497.418L467.048 328.891L466.838 311.202Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M491.6 210.249L491.613 330.117L491.6 210.249Z",
    fill: "#131F2E"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M491.6 210.249L491.613 330.117",
    stroke: "#F7F9F9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M497.66 208.131L497.633 330.117L497.66 208.131Z",
    fill: "#131F2E"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M497.66 208.131L497.633 330.117",
    stroke: "#F7F9F9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M503.708 208.211V330.117V208.211Z",
    fill: "#131F2E"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M503.708 208.211V330.117",
    stroke: "#F7F9F9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M509.675 210.075V329.743V210.075Z",
    fill: "#131F2E"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M509.675 210.075V329.743",
    stroke: "#F7F9F9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M515.802 210.129V329.797V210.129Z",
    fill: "#131F2E"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M515.802 210.129V329.797",
    stroke: "#F7F9F9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M521.77 210.022V329.69V210.022Z",
    fill: "#131F2E"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M521.77 210.022V329.69",
    stroke: "#F7F9F9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M527.791 209.809V329.477V209.809Z",
    fill: "#131F2E"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M527.791 209.809V329.477",
    stroke: "#F7F9F9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M506.159 221.691V225.634L529.283 225.421V221.372L506.159 221.691Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M504.88 224.568V251.315H530.455L530.402 224.195L504.88 224.568Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M509.569 248.331C509.569 249.273 508.806 250.036 507.864 250.036C506.922 250.036 506.159 249.273 506.159 248.331C506.159 247.389 506.922 246.626 507.864 246.626C508.805 246.626 509.569 247.389 509.569 248.331Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M529.176 248.331C529.176 249.273 528.413 250.036 527.471 250.036C526.529 250.036 525.766 249.273 525.766 248.331C525.766 247.389 526.529 246.626 527.471 246.626C528.412 246.626 529.176 247.389 529.176 248.331Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M509.515 227.019C509.515 227.961 508.752 228.724 507.81 228.724C506.868 228.724 506.105 227.961 506.105 227.019C506.105 226.077 506.868 225.314 507.81 225.314C508.752 225.314 509.515 226.077 509.515 227.019Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M529.336 227.178C529.336 228.12 528.573 228.883 527.631 228.883C526.689 228.883 525.926 228.12 525.926 227.178C525.926 226.236 526.689 225.473 527.631 225.473C528.572 225.473 529.336 226.237 529.336 227.178Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M533.865 210.022V329.69V210.022Z",
    fill: "#131F2E"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M533.865 210.022V329.69",
    stroke: "#F7F9F9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M539.619 209.702V329.37V209.702Z",
    fill: "#131F2E"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M539.619 209.702V329.37",
    stroke: "#F7F9F9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M545.267 209.756V329.424V209.756Z",
    fill: "#131F2E"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M545.267 209.756V329.424",
    stroke: "#F7F9F9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M550.808 209.543V329.211V209.543Z",
    fill: "#131F2E"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M550.808 209.543V329.211",
    stroke: "#F7F9F9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M556.029 219.4V297.891V219.4Z",
    fill: "#131F2E"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M556.029 219.4V297.891",
    stroke: "#F7F9F9",
    strokeWidth: 0.997
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M505.093 222.65L504.986 206.453L554.111 208.904C555.606 209.273 556.733 210.102 557.095 211.888V224.675L533.012 222.437L505.093 222.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M485.579 210.408L485.592 330.276L485.579 210.408Z",
    fill: "#131F2E"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M485.579 210.408L485.592 330.276",
    stroke: "#F7F9F9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M479.572 274.564V329.717V274.564Z",
    fill: "#131F2E"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M479.572 274.564V329.717",
    stroke: "#F7F9F9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M478.559 306.673H552.113H478.559Z",
    fill: "#131F2E"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M478.559 306.673H552.113",
    stroke: "#F7F9F9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M473.551 312.311V330.183V312.311Z",
    fill: "#131F2E"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M473.551 312.311V330.183",
    stroke: "#F7F9F9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M468.542 311.682V329.046V311.682Z",
    fill: "#131F2E"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M468.542 311.682V329.046",
    stroke: "#F7F9F9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M467.361 328.69L553.835 328.941L521.729 340.229L497.49 340.223L467.361 328.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M108.363 234.56H103.088V290.168H108.363V234.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4019 291.826H74.0029V295.594H95.4019V291.826Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6719 353.085C93.7819 360.017 102.522 359.791 104.934 353.236L106.064 348.866",
    fill: "#131F2E"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6719 353.085C93.7819 360.017 102.522 359.791 104.934 353.236L106.064 348.866",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1089 446.67H91.5969L91.6719 351.88L78.1089 351.729V446.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7579 446.821L88.5829 351.88H78.1089V446.746L88.7579 446.821Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.0763
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M95.289 348.64H74.116V352.106H95.289V348.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M110.924 294.84H60.1379V349.243H110.924V294.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M108.664 298.306H62.3989V345.777H108.664V298.306Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0579 337.394C75.0579 340.755 72.4599 343.479 69.2559 343.479C66.0519 343.479 63.4539 340.755 63.4539 337.394C63.4539 334.033 66.0519 331.309 69.2559 331.309C72.4599 331.309 75.0579 334.034 75.0579 337.394Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M87.114 337.421C87.114 340.796 84.516 343.532 81.312 343.532C78.108 343.532 75.51 340.796 75.51 337.421C75.51 334.046 78.108 331.31 81.312 331.31C84.516 331.31 87.114 334.045 87.114 337.421Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1699 337.374C99.1699 340.723 96.5719 343.439 93.3679 343.439C90.1639 343.439 87.5659 340.724 87.5659 337.374C87.5659 334.024 90.1639 331.309 93.3679 331.309C96.5719 331.309 99.1699 334.024 99.1699 337.374Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M72.819 337.337C72.819 339.18 71.325 340.674 69.482 340.674C67.639 340.674 66.145 339.18 66.145 337.337C66.145 335.494 67.639 334 69.482 334C71.325 334 72.819 335.494 72.819 337.337Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8749 337.337C84.8749 339.18 83.3809 340.674 81.5379 340.674C79.6949 340.674 78.2009 339.18 78.2009 337.337C78.2009 335.494 79.6949 334 81.5379 334C83.3809 334 84.8749 335.494 84.8749 337.337Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9308 337.337C96.9308 339.18 95.4368 340.674 93.5938 340.674C91.7508 340.674 90.2568 339.18 90.2568 337.337C90.2568 335.494 91.7508 334 93.5938 334C95.4368 334 96.9308 335.494 96.9308 337.337Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M65.111 301.923H106.704C107.37 301.923 107.91 302.463 107.91 303.129V327.844C107.91 328.51 107.37 329.05 106.704 329.05H65.111C64.445 329.05 63.905 328.51 63.905 327.844V303.129C63.906 302.462 64.445 301.923 65.111 301.923Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M106.253 304.786H65.865V326.788H106.253V304.786Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M102.334 289.867H109.869C110.535 289.867 111.075 290.407 111.075 291.073V293.484C111.075 294.15 110.535 294.69 109.869 294.69H102.334C101.668 294.69 101.128 294.15 101.128 293.484V291.073C101.129 290.406 101.668 289.867 102.334 289.867Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M103.841 227.175H108.362C109.694 227.175 110.773 228.255 110.773 229.586V232.751C110.773 234.083 109.693 235.162 108.362 235.162H103.841C102.509 235.162 101.43 234.082 101.43 232.751V229.586C101.43 228.255 102.51 227.175 103.841 227.175Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M101.43 230.642H73.7009H101.43Z",
    fill: "#131F2E"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M101.43 230.642H73.7009",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M98.115 216.174V244.506V216.174Z",
    fill: "#131F2E"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M98.115 216.174V244.506",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M94.196 218.661V242.17V218.661Z",
    fill: "#131F2E"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M94.196 218.661V242.17",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M90.241 221.713V239.27V221.713Z",
    fill: "#131F2E"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M90.241 221.713V239.27",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3979 225.367V236.933V225.367Z",
    fill: "#131F2E"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3979 225.367V236.933",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M82.781 227.778V233.467V227.778Z",
    fill: "#131F2E"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M82.781 227.778V233.467",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5239 228.984V232.45V228.984Z",
    fill: "#131F2E"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5239 228.984V232.45",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M478.491 198.212V168.939C478.065 167.091 476.438 166.758 474.893 166.321L327 166.66V198.307L478.491 198.212Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M442.168 198.472L519.514 198.074L519.448 166.592H444.753C442.21 166.584 441.68 167.648 441.771 169.044L442.168 198.472Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M325.218 198.46L325.005 168.836C324.908 166.773 326.286 166.313 327.669 166.172H550.701C553.384 166.443 554.455 167.77 554.377 169.848V198.46H325.218Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M374.907 166.195V150.421L386.506 147.306H415.005L421.832 150.355V166.262L374.907 166.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M387.698 147.439V165.997V147.439Z",
    fill: "#131F2E"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M387.698 147.439V165.997",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M413.745 147.439V166.129V147.439Z",
    fill: "#131F2E"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M413.745 147.439V166.129",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M394.326 149.096H405.262C405.701 149.096 406.057 149.482 406.057 149.958V151.416C406.057 151.892 405.701 152.278 405.262 152.278H394.326C393.887 152.278 393.531 151.892 393.531 151.416V149.958C393.531 149.481 393.887 149.096 394.326 149.096Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M394.359 153.139H405.295C405.734 153.139 406.09 153.525 406.09 154.001V155.459C406.09 155.935 405.734 156.321 405.295 156.321H394.359C393.92 156.321 393.564 155.935 393.564 155.459V154C393.564 153.524 393.92 153.139 394.359 153.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M394.359 157.181H405.295C405.734 157.181 406.09 157.567 406.09 158.043V159.501C406.09 159.977 405.734 160.363 405.295 160.363H394.359C393.92 160.363 393.564 159.977 393.564 159.501V158.043C393.564 157.567 393.92 157.181 394.359 157.181Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M363 204.189V198.274V204.189Z",
    fill: "#131F2E"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M363 204.189V198.274",
    stroke: "#F7F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcp);
export default __webpack_public_path__ + "static/media/pcp.be8603d532b7de6caae46ce1e7d8b8a2.svg";
export { ForwardRef as ReactComponent };